import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import { HyphenIcon, TextTooltip } from "@transfr-inc/dashboard-components";
import { formatDateDigits } from "@transfr-inc/dashboard-components/utils";

import { toScorePercent } from "@lib/utils/score.utils";
import { MasteryStatus } from "@models";

import { getStatusConfig } from "./cell.utils";

import "./mastery.cell.scss";

export default ({ status, score, exempt, scoreOverrideAt }) => {
  const { classname, icon } = getStatusConfig({ status, masteryScore: score });

  if (exempt) {
    return (
      <div className={clsx("mastery-cell", "ban")}>
        <FontAwesomeIcon icon={["fa-regular", "ban"]} />
        Exempt
      </div>
    );
  }

  // Set when an instructor typed the score in; cleared server-side on the next
  // sim run, so it always describes the score on screen.
  const overridden = !!scoreOverrideAt;

  // formatDateDigits takes the raw API string; formatDate needs a Date.
  const tooltipText = overridden
    ? `${status} • Score overridden ${formatDateDigits(scoreOverrideAt)}`
    : status;

  return (
    <div className={clsx("mastery-cell", classname)}>
      {status !== MasteryStatus.NotStarted && status ? (
        <>
          <TextTooltip
            text={tooltipText}
            distance={12}
            theme={`gb-${classname}`}
          >
            <div className="mastery-value">
              <FontAwesomeIcon icon={icon} />
              <span>{toScorePercent(score)}%</span>
              {overridden && (
                <FontAwesomeIcon
                  icon={["fa-light", "pencil"]}
                  className="override-icon"
                />
              )}
            </div>
          </TextTooltip>
        </>
      ) : (
        <HyphenIcon />
      )}
    </div>
  );
};
